(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class LmLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lm-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        tooltip.classList.remove('show')
        tooltip.classList.add('hiding')
        setTimeout(() => {
          tooltip.classList.remove('hiding')
        }, 200);
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', LmLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-decal-standard-qa"]) return;
  try {
    
  (() => {
    const SIZE_ORDER = ['2x2', '2x4', '3x3', '4x4', '5x5', '6x6'];
    const AMOUNT_ORDER = ['25', '50', '100', '200', '500'];
    const shapesFor = (size) => size === '2x4' ? ['Oval', 'Rectangle', 'Contour Cut'] : ['Circle', 'Square', 'Contour Cut'];
    const shapeKey = (shape) => String(shape).replace(/\s+/g, '').toLowerCase();
    const canonicalShape = (shape) => ['Circle', 'Square', 'Oval', 'Rectangle', 'Contour Cut'].find((value) => shapeKey(value) === shapeKey(shape));
    const variantKey = (size, amount, shape) => [size, amount, shapeKey(shape)].join('|');
    const validateCatalog = (config) => {
      if (!config || String(config.productId) !== '9490403491937' || config.currency !== 'USD' || config.shopCurrency !== 'USD') throw new Error('configuration');
      if (JSON.stringify(config.optionNames) !== JSON.stringify(['Size', 'Amount', 'Shape'])) throw new Error('options');
      if (!Array.isArray(config.variants) || config.variants.length !== 90) throw new Error('count');
      const variants = new Map();
      const ids = new Set();
      config.variants.forEach((variant) => {
        if (!variant || !Number.isSafeInteger(variant.id) || variant.id <= 0 || ids.has(variant.id)) throw new Error('id');
        if (!Number.isSafeInteger(variant.price) || variant.price <= 0 || typeof variant.available !== 'boolean') throw new Error('price');
        if (!SIZE_ORDER.includes(variant.option1) || !AMOUNT_ORDER.includes(variant.option2)) throw new Error('dimensions');
        const shape = canonicalShape(variant.option3);
        if (!shape || !shapesFor(variant.option1).includes(shape)) throw new Error('shape');
        const key = variantKey(variant.option1, variant.option2, shape);
        if (variants.has(key)) throw new Error('duplicate');
        variants.set(key, Object.freeze({ ...variant, shape }));
        ids.add(variant.id);
      });
      SIZE_ORDER.forEach((size) => AMOUNT_ORDER.forEach((amount) => shapesFor(size).forEach((shape) => {
        if (!variants.has(variantKey(size, amount, shape))) throw new Error('missing');
      })));
      return variants;
    };
    const mappedShape = (previous, size) => {
      const available = shapesFor(size);
      const canonical = canonicalShape(previous);
      if (available.includes(canonical)) return canonical;
      return ({ Circle: 'Oval', Square: 'Rectangle', Oval: 'Circle', Rectangle: 'Square' })[canonical] || available[0];
    };
    const interpolate = (value, replacements) => String(value).replace(/\[\[([a-z_]+)\]\]/g, (match, key) => replacements[key] ?? match);
    const initialize = (root) => {
      if (root.dataset.standardReady === 'true') return;
      const form = root.querySelector('[data-standard-form]');
      if (!form) return;
      root.dataset.standardReady = 'true';
      const fields = form.querySelector('[data-standard-fields]');
      const size = form.querySelector('[data-standard-size]');
      const amount = form.querySelector('[data-standard-amount]');
      const shape = form.querySelector('[data-standard-shape]');
      const id = form.querySelector('[data-standard-id]');
      const quantity = form.querySelector('[data-standard-quantity]');
      const pack = form.querySelector('[data-standard-pack]');
      const unit = form.querySelector('[data-standard-unit]');
      const price = form.querySelector('[data-standard-price]');
      const summary = form.querySelector('[data-standard-summary]');
      const submit = form.querySelector('[data-standard-submit]');
      const error = form.querySelector('[data-standard-error]');
      const artwork = form.querySelector('[data-standard-artwork]');
      const surface = form.querySelector('[data-standard-surface]');
      const notes = form.querySelector('[data-standard-notes]');
      let strings;
      let catalog;
      let config;
      let submitting = false;
      let initialized = false;
      const blockConfiguration = () => {
        fields.disabled = true;
        [id, quantity, pack, unit].forEach((input) => { input.disabled = true; });
        id.value = '';
        submit.disabled = true;
        error.hidden = false;
        error.textContent = strings?.configurationError || root.querySelector('noscript')?.textContent || '';
      };
      form.addEventListener('submit', (event) => {
        event.stopImmediatePropagation();
        if (!initialized || submitting) { event.preventDefault(); return; }
        const selected = catalog.get(variantKey(size.value, amount.value, shape.value));
        validateFields();
        if (!selected?.available || !form.reportValidity()) {
          event.preventDefault();
          if (!selected?.available) { error.textContent = strings.unavailable; error.hidden = false; error.focus(); }
          return;
        }
        setNativeInputs(selected);
        submitting = true;
        form.setAttribute('aria-busy', 'true');
        submit.disabled = true;
        submit.textContent = strings.adding;
      }, true);
      try {
        strings = JSON.parse(root.querySelector('[data-standard-strings]').textContent);
        config = JSON.parse(root.querySelector('[data-standard-config]').textContent);
        catalog = validateCatalog(config);
      } catch { blockConfiguration(); return; }
      const nativeRequestSubmit = typeof HTMLFormElement === 'function' ? HTMLFormElement.prototype.requestSubmit : null;
      if (typeof nativeRequestSubmit !== 'function') { blockConfiguration(); return; }
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: config.currency, currencyDisplay: 'code' });
      const variants = [...catalog.values()];
      const initial = variants.find((variant) => String(variant.id) === String(config.selectedId)) || variants.find((variant) => variant.available) || variants[0];
      const fill = (select, values, selected, label, available) => {
        select.replaceChildren(...values.map((value) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = label(value);
          option.disabled = !available(value);
          option.selected = value === selected;
          return option;
        }));
        select.value = selected;
      };
      const sizeLabel = (value) => `${value.replace('x', ' × ')} ${strings.inches}`;
      const setNativeInputs = (selected) => {
        id.value = selected.available ? String(selected.id) : '';
        quantity.value = '1';
        pack.value = interpolate(strings.packContents, { pieces: selected.option2 });
        [id, quantity, pack, unit].forEach((input) => { input.disabled = !selected.available; });
      };
      const updateSummary = () => {
        const selected = catalog.get(variantKey(size.value, amount.value, shape.value));
        if (!selected) { blockConfiguration(); return; }
        setNativeInputs(selected);
        price.textContent = money.format(selected.price / 100);
        summary.textContent = interpolate(strings.summary, { pieces: selected.option2, size: sizeLabel(selected.option1), shape: strings.shapes[selected.shape] });
        submit.disabled = submitting || !selected.available;
        submit.textContent = submitting ? strings.adding : strings.add;
        error.hidden = selected.available;
        error.textContent = selected.available ? '' : strings.unavailable;
      };
      const updateChoices = (selectedShape) => {
        const selectedAmount = amount.value || initial.option2;
        fill(amount, AMOUNT_ORDER, selectedAmount, (value) => `${value} ${strings.pieces}`, (value) => variants.some((variant) => variant.option1 === size.value && variant.option2 === value && variant.available));
        fill(shape, shapesFor(size.value), mappedShape(selectedShape, size.value), (value) => strings.shapes[value], (value) => Boolean(catalog.get(variantKey(size.value, amount.value, value))?.available));
        updateSummary();
      };
      const validateFields = () => {
        [surface, notes].forEach((input) => input.setCustomValidity(input.value.trim() ? '' : strings.requiredText));
        const file = artwork.files?.[0];
        artwork.setCustomValidity(file && (!/\.(pdf|png|jpe?g|svg)$/i.test(file.name) || file.size <= 0) ? strings.invalidFile : '');
      };
      fill(size, SIZE_ORDER, initial.option1, sizeLabel, (value) => variants.some((variant) => variant.option1 === value && variant.available));
      amount.value = initial.option2;
      fields.disabled = false;
      initialized = true;
      updateChoices(initial.shape);
      size.addEventListener('change', () => updateChoices(shape.value));
      amount.addEventListener('change', () => updateChoices(shape.value));
      shape.addEventListener('change', updateSummary);
      [surface, notes].forEach((input) => input.addEventListener('input', validateFields));
      artwork.addEventListener('change', validateFields);
      const requestNativeSubmission = () => {
        if (!initialized || submitting || submit.disabled) return;
        validateFields();
        nativeRequestSubmit.call(form);
      };
      submit.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        requestNativeSubmission();
      });
      form.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' || event.target !== surface || event.isComposing || event.keyCode === 229) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!event.repeat) requestNativeSubmission();
      }, true);
      const restore = () => {
        submitting = false;
        form.removeAttribute('aria-busy');
        updateChoices(shape.value || initial.shape);
        validateFields();
      };
      window.addEventListener('pageshow', restore);
      form.addEventListener('reset', () => requestAnimationFrame(() => {
        size.value = initial.option1;
        amount.value = initial.option2;
        shape.value = initial.shape;
        restore();
      }));
    };
    const initializeAll = (scope) => scope.querySelectorAll('[data-sg-decal-standard]').forEach(initialize);
    initializeAll(document);
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-decal-standard"]) return;
  try {
    
  (() => {
    const SIZE_ORDER = ['2x2', '2x4', '3x3', '4x4', '5x5', '6x6'];
    const AMOUNT_ORDER = ['25', '50', '100', '200', '500'];
    const shapesFor = (size) => size === '2x4' ? ['Oval', 'Rectangle', 'Contour Cut'] : ['Circle', 'Square', 'Contour Cut'];
    const shapeKey = (shape) => String(shape).replace(/\s+/g, '').toLowerCase();
    const canonicalShape = (shape) => ['Circle', 'Square', 'Oval', 'Rectangle', 'Contour Cut'].find((value) => shapeKey(value) === shapeKey(shape));
    const variantKey = (size, amount, shape) => [size, amount, shapeKey(shape)].join('|');
    const validateCatalog = (config) => {
      if (!config || String(config.productId) !== '7197851451489' || config.currency !== 'USD' || config.shopCurrency !== 'USD') throw new Error('configuration');
      if (JSON.stringify(config.optionNames) !== JSON.stringify(['Size', 'Amount', 'Shape'])) throw new Error('options');
      if (!Array.isArray(config.variants) || config.variants.length !== 90) throw new Error('count');
      const variants = new Map();
      const ids = new Set();
      config.variants.forEach((variant) => {
        if (!variant || !Number.isSafeInteger(variant.id) || variant.id <= 0 || ids.has(variant.id)) throw new Error('id');
        if (!Number.isSafeInteger(variant.price) || variant.price <= 0 || typeof variant.available !== 'boolean') throw new Error('price');
        if (!SIZE_ORDER.includes(variant.option1) || !AMOUNT_ORDER.includes(variant.option2)) throw new Error('dimensions');
        const shape = canonicalShape(variant.option3);
        if (!shape || !shapesFor(variant.option1).includes(shape)) throw new Error('shape');
        const key = variantKey(variant.option1, variant.option2, shape);
        if (variants.has(key)) throw new Error('duplicate');
        variants.set(key, Object.freeze({ ...variant, shape }));
        ids.add(variant.id);
      });
      SIZE_ORDER.forEach((size) => AMOUNT_ORDER.forEach((amount) => shapesFor(size).forEach((shape) => {
        if (!variants.has(variantKey(size, amount, shape))) throw new Error('missing');
      })));
      return variants;
    };
    const mappedShape = (previous, size) => {
      const available = shapesFor(size);
      const canonical = canonicalShape(previous);
      if (available.includes(canonical)) return canonical;
      return ({ Circle: 'Oval', Square: 'Rectangle', Oval: 'Circle', Rectangle: 'Square' })[canonical] || available[0];
    };
    const interpolate = (value, replacements) => String(value).replace(/\[\[([a-z_]+)\]\]/g, (match, key) => replacements[key] ?? match);
    const initialize = (root) => {
      if (root.dataset.standardReady === 'true') return;
      const form = root.querySelector('[data-standard-form]');
      if (!form) return;
      root.dataset.standardReady = 'true';
      const fields = form.querySelector('[data-standard-fields]');
      const size = form.querySelector('[data-standard-size]');
      const amount = form.querySelector('[data-standard-amount]');
      const shape = form.querySelector('[data-standard-shape]');
      const id = form.querySelector('[data-standard-id]');
      const quantity = form.querySelector('[data-standard-quantity]');
      const pack = form.querySelector('[data-standard-pack]');
      const unit = form.querySelector('[data-standard-unit]');
      const price = form.querySelector('[data-standard-price]');
      const summary = form.querySelector('[data-standard-summary]');
      const submit = form.querySelector('[data-standard-submit]');
      const error = form.querySelector('[data-standard-error]');
      const artwork = form.querySelector('[data-standard-artwork]');
      const surface = form.querySelector('[data-standard-surface]');
      const notes = form.querySelector('[data-standard-notes]');
      let strings;
      let catalog;
      let config;
      let submitting = false;
      let initialized = false;
      const blockConfiguration = () => {
        fields.disabled = true;
        [id, quantity, pack, unit].forEach((input) => { input.disabled = true; });
        id.value = '';
        submit.disabled = true;
        error.hidden = false;
        error.textContent = strings?.configurationError || root.querySelector('noscript')?.textContent || '';
      };
      form.addEventListener('submit', (event) => {
        event.stopImmediatePropagation();
        if (!initialized || submitting) { event.preventDefault(); return; }
        const selected = catalog.get(variantKey(size.value, amount.value, shape.value));
        validateFields();
        if (!selected?.available || !form.reportValidity()) {
          event.preventDefault();
          if (!selected?.available) { error.textContent = strings.unavailable; error.hidden = false; error.focus(); }
          return;
        }
        setNativeInputs(selected);
        submitting = true;
        form.setAttribute('aria-busy', 'true');
        submit.disabled = true;
        submit.textContent = strings.adding;
      }, true);
      try {
        strings = JSON.parse(root.querySelector('[data-standard-strings]').textContent);
        config = JSON.parse(root.querySelector('[data-standard-config]').textContent);
        catalog = validateCatalog(config);
      } catch { blockConfiguration(); return; }
      const nativeRequestSubmit = typeof HTMLFormElement === 'function' ? HTMLFormElement.prototype.requestSubmit : null;
      if (typeof nativeRequestSubmit !== 'function') { blockConfiguration(); return; }
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: config.currency, currencyDisplay: 'code' });
      const variants = [...catalog.values()];
      const initial = variants.find((variant) => String(variant.id) === String(config.selectedId)) || variants.find((variant) => variant.available) || variants[0];
      const fill = (select, values, selected, label, available) => {
        select.replaceChildren(...values.map((value) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = label(value);
          option.disabled = !available(value);
          option.selected = value === selected;
          return option;
        }));
        select.value = selected;
      };
      const sizeLabel = (value) => `${value.replace('x', ' × ')} ${strings.inches}`;
      const setNativeInputs = (selected) => {
        id.value = selected.available ? String(selected.id) : '';
        quantity.value = '1';
        pack.value = interpolate(strings.packContents, { pieces: selected.option2 });
        [id, quantity, pack, unit].forEach((input) => { input.disabled = !selected.available; });
      };
      const updateSummary = () => {
        const selected = catalog.get(variantKey(size.value, amount.value, shape.value));
        if (!selected) { blockConfiguration(); return; }
        setNativeInputs(selected);
        price.textContent = money.format(selected.price / 100);
        summary.textContent = interpolate(strings.summary, { pieces: selected.option2, size: sizeLabel(selected.option1), shape: strings.shapes[selected.shape] });
        submit.disabled = submitting || !selected.available;
        submit.textContent = submitting ? strings.adding : strings.add;
        error.hidden = selected.available;
        error.textContent = selected.available ? '' : strings.unavailable;
      };
      const updateChoices = (selectedShape) => {
        const selectedAmount = amount.value || initial.option2;
        fill(amount, AMOUNT_ORDER, selectedAmount, (value) => `${value} ${strings.pieces}`, (value) => variants.some((variant) => variant.option1 === size.value && variant.option2 === value && variant.available));
        fill(shape, shapesFor(size.value), mappedShape(selectedShape, size.value), (value) => strings.shapes[value], (value) => Boolean(catalog.get(variantKey(size.value, amount.value, value))?.available));
        updateSummary();
      };
      const validateFields = () => {
        [surface, notes].forEach((input) => input.setCustomValidity(input.value.trim() ? '' : strings.requiredText));
        const file = artwork.files?.[0];
        artwork.setCustomValidity(file && (!/\.(pdf|png|jpe?g|svg)$/i.test(file.name) || file.size <= 0) ? strings.invalidFile : '');
      };
      fill(size, SIZE_ORDER, initial.option1, sizeLabel, (value) => variants.some((variant) => variant.option1 === value && variant.available));
      amount.value = initial.option2;
      fields.disabled = false;
      initialized = true;
      updateChoices(initial.shape);
      size.addEventListener('change', () => updateChoices(shape.value));
      amount.addEventListener('change', () => updateChoices(shape.value));
      shape.addEventListener('change', updateSummary);
      [surface, notes].forEach((input) => input.addEventListener('input', validateFields));
      artwork.addEventListener('change', validateFields);
      const requestNativeSubmission = () => {
        if (!initialized || submitting || submit.disabled) return;
        validateFields();
        nativeRequestSubmit.call(form);
      };
      submit.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        requestNativeSubmission();
      });
      form.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' || event.target !== surface || event.isComposing || event.keyCode === 229) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!event.repeat) requestNativeSubmission();
      }, true);
      const restore = () => {
        submitting = false;
        form.removeAttribute('aria-busy');
        updateChoices(shape.value || initial.shape);
        validateFields();
      };
      window.addEventListener('pageshow', restore);
      form.addEventListener('reset', () => requestAnimationFrame(() => {
        size.value = initial.option1;
        amount.value = initial.option2;
        shape.value = initial.shape;
        restore();
      }));
    };
    const initializeAll = (scope) => scope.querySelectorAll('[data-sg-decal-standard]').forEach(initialize);
    initializeAll(document);
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
